import { ManageAgent, ManageAgentProps } from './ManageAgent';
import { AgentActionsProvider } from './contexts/AgentActionsContext';
import { InsightsProvider } from './contexts/InsightsContext';
import { TransientSelectedActionsProvider } from './contexts/TransientSelectedActionsContext';
import { withIntegrationApp } from 'src/hocs/withIntegrationApp';

const BaseManageAgentProvider = (props: ManageAgentProps) => {
  return (
    <AgentActionsProvider>
      <InsightsProvider>
        <TransientSelectedActionsProvider>
          <ManageAgent {...props} />
        </TransientSelectedActionsProvider>
      </InsightsProvider>
    </AgentActionsProvider>
  );
};

export const ManageAgentProvider = withIntegrationApp(BaseManageAgentProvider);
